import {
  Button,
  Card,
  DatePicker,
  Dialog,
  Input,
  Message,
  Radio,
  Select,
  Table,
} from '@alifd/next';
import { Cascader, Form, InputNumber } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import EditDocument from '@/components/UI/EditDocument';

import client from '../../../../lib/feathers';
import EditBalance from './EditBalance';
import EditLongTermRepairIncome from './EditLongTermRepairIncome';
import EditRepairSubjectButtonWithModal from './EditRepairSubjectButtonWithModal';
import EditSubjects from './EditSubjects';
import styles from './index.module.scss';
const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
const Option = Select.Option;

const communityDevice = client.service('communityDevice');
const longTermFix = client.service('longTermFix');
const communityData = client.service('communityData');
const accountingSubjects = client.service('accountingSubjects');
const publicInformationCount = client.service('publicInformationCount');
const publicInformationHour = client.service('publicInformationHour');

const RepairBudgetList = ({
  backStageUpdateTrigger,
  setBackStageUpdateTrigger,
}) => {
  const [longTermFixAddForm] = Form.useForm();
  const [longTermFixRecordForm] = Form.useForm();
  const [communityDeviceDialog, setCommunityDeviceDialog] = useState(false);
  const [communityDeviceArr, setCommunityDeviceArr] = useState([]);
  const [communityDeviceUpdate, setCommunityDeviceUpdate] = useState({});
  const [communityDeviceStatus, setCommunityDeviceStatus] = useState('insert');
  const [annualFixBudgetArr, setAnnualFixBudgetArr] = useState([]);
  const [annualFixBudgetDialog, setAnnualFixBudgetDialog] = useState(false);
  const [annualFixBudgetRecordDialog, setAnnualFixBudgetRecordDialog] =
    useState(false);
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [repairCategory, setRepairCategory] = useState('communityDevice');
  const [repairAccountingSubject, setRepairAccountingSubject] = useState({});
  const [repairSubjects, setRepairSubjects] = useState([]);
  const [currentCycle, setCurrentCycle] = useState('year');

  useEffect(() => {
    // 長期修繕
    longTermFix
      .find({ query: {} })
      .then((result) => {
        setAnnualFixBudgetArr(result.data);
      })
      .catch((error) => {
        console.error(error);
      });

    // 取得社區資料與長期修繕會計科目

    communityData
      .find({})
      .then((communityDataRes) => {
        if (communityDataRes.data.length > 0) {
          const data = communityDataRes.data[0];
          setCommunityDataArr(data);
          if (data.repairSubjectId) {
            accountingSubjects
              .find(data.repairSubjectId)
              .then((accountingSubjectsRes) => {
                if (accountingSubjectsRes.data.length > 0) {
                  setRepairAccountingSubject(
                    accountingSubjectsRes.data.find(
                      (d) => d._id === data.repairSubjectId
                    )
                  );
                }
              });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });

    // 取得修繕項目

    client
      .service('repairSubjects')
      .find({
        query: {
          $sort: {
            _id: -1,
          },
        },
      })
      .then((result) => {
        setRepairSubjects(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [backStageUpdateTrigger]);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  const onFinish = (value) => {
    let uploadData = {};
    const {
      category,
      deviceId,
      name,
      repairExpenses,
      repairStartAndEnd,
      repairCycle,
      repairTime,
    } = value;
    if (['communityDevice', 'publicInformation'].includes(value.category)) {
      const repairObject = communityDeviceArr.find((d) => d._id === deviceId);
      uploadData.name = repairObject.name;
      uploadData.deviceId = repairObject._id;
    } else {
      uploadData.name = name;
    }
    if (communityDeviceStatus === 'insert') {
      uploadData.repairBalance = repairExpenses;
    }

    uploadData = {
      ...uploadData,
      category,
      repairExpenses,
      repairRecords: [],
      repairStartYear: repairStartAndEnd[0].valueOf(),
      repairEndYear: repairStartAndEnd[1].valueOf(),
      repairCycle,
      repairTime: repairTime.sort((a, b) => {
        const stringA = a.map((n) => n.padStart(2, '0')).join('');
        const stringB = b.map((n) => n.padStart(2, '0')).join('');
        return stringA.localeCompare(stringB);
      }),
    };

    if (communityDeviceStatus === 'insert') {
      longTermFix
        .create(uploadData)
        .then(() => {
          Message.success('新增成功');
          setCurrentCycle('year');
          setCommunityDeviceDialog(false);
          setBackStageUpdateTrigger({});
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      longTermFix
        .patch(communityDeviceUpdate._id, uploadData)
        .then(() => {
          Message.success('修改成功');
          setCurrentCycle('year');
          setCommunityDeviceDialog(false);
          setBackStageUpdateTrigger({});
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const onFinishRecord = (value) => {
    const newRecordObject = [
      ...communityDeviceUpdate.repairRecords,
      {
        ...value,
        createdTime: moment().valueOf(),
      },
    ];
    longTermFix
      .patch(communityDeviceUpdate._id, {
        repairRecords: newRecordObject,
        repairBalance: parseInt(
          communityDeviceUpdate.repairBalance - value.repairRecordMoney,
          10
        ),
      })
      .then(() => {
        Message.success('新增修繕記錄成功');
        setBackStageUpdateTrigger({});
        setAnnualFixBudgetRecordDialog(false);
        longTermFix
          .find({ query: { _id: communityDeviceUpdate._id } })
          .then((result) => {
            setCommunityDeviceUpdate(result.data[0]);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    (async () => {
      if (repairCategory === 'communityDevice') {
        communityDevice
          .find({
            query: {
              deviceType: '非消耗品',
            },
          })
          .then((result) => {
            const newResult = result.data.map((item) => {
              const newItem = item;
              newItem.name = item.deviceName;
              return newItem;
            });
            setCommunityDeviceArr(newResult);
          })
          .catch((error) => {
            console.error(error);
          });
      } else if (repairCategory === 'publicInformation') {
        let newPublic = [];
        await publicInformationHour
          .find({ query: {} })
          .then((result) => {
            const newResult = result.data.map((item) => {
              const newItem = item;
              newItem.name = item.publicName;
              return newItem;
            });
            newPublic = [...newPublic, ...newResult];
          })
          .catch((error) => {
            console.error(error);
          });
        await publicInformationCount
          .find({ query: {} })
          .then((result) => {
            const newResult = result.data.map((item) => {
              const newItem = item;
              newItem.name = item.publicName;
              return newItem;
            });
            newPublic = [...newPublic, ...newResult];
          })
          .catch((error) => {
            console.error(error);
          });
        setCommunityDeviceArr(newPublic);
      }
    })();
  }, [repairCategory]);

  const getBudgetReducer = (limit = Infinity) => {
    return (total, current) => {
      const remainYear = moment(current.repairEndYear).diff(moment(), 'years');
      if (remainYear > 0 && remainYear < limit) {
        return total + current.repairBalance;
      }
      return total;
    };
  };

  const hasRepairSetting = useMemo(() => {
    const { repairPer, repairSubjectId, repairDepends } = communityDataArr;
    return repairPer && repairSubjectId && repairDepends;
  }, [communityDataArr]);

  const getRepairTimeOptions = useCallback((cycle) => {
    const yearOptions = Array(12)
      .fill(0)
      .map((_, i) => {
        return {
          value: `${i + 1}`,
          label: `${i + 1}月`,
          children: Array(moment().set('month', i).daysInMonth())
            .fill(0)
            .map((_2, j) => ({
              value: `${j + 1}`,
              label: `${i + 1}月${j + 1}日`,
            })),
        };
      });
    const monthOptions = Array(31)
      .fill(0)
      .map((_, i) => ({
        value: `${i + 1}`,
        label: `${i + 1}日`,
      }));
    const weekOptions = Array(7)
      .fill(0)
      .map((_, i) => ({
        value: i.toString(),
        label: moment().weekday(i).format('dddd'),
      }));
    switch (cycle) {
      case 'year':
        return yearOptions;
      case 'month':
        return monthOptions;
      case 'week':
        return weekOptions;
      default:
        return [];
    }
  }, []);

  const handleFieldsChange = useCallback(
    (changedFields) => {
      const name = changedFields[0].name[0];
      const value = changedFields[0].value;
      if (name === 'repairCycle') {
        longTermFixAddForm.setFieldValue('repairTime', []);
        setCurrentCycle(value);
      }
    },
    [longTermFixAddForm]
  );

  return (
    <>
      {/* 長期修繕說明處 */}
      <div className={styles.functions}>
        <EditLongTermRepairIncome {...{ setBackStageUpdateTrigger }} />
        <EditSubjects
          {...{
            backStageUpdateTrigger,
            setBackStageUpdateTrigger,
          }}
        />
      </div>
      <Card free>
        <Card.Content>
          {/* {annualFixBudgetArr.length > 0 && ( */}
          <div className={styles.repairBudgetDisplay}>
            {/* {hasRepairSetting && ( */}
            <div className={styles.repairInfo}>
              <p>{`長期修繕經費來源：${
                communityDataArr.repairDepends
                  ? `依據${communityDataArr.repairDepends}，`
                  : ''
              }${
                repairAccountingSubject.subjectName
                  ? `從會計科目${repairAccountingSubject.subjectName}(${repairAccountingSubject.subjectCode})`
                  : ''
              }${
                communityDataArr.repairPer
                  ? `提撥${communityDataArr.repairPer}％`
                  : ''
              }`}</p>
              {communityDataArr.repairDependsFile?.length > 0 && (
                <a
                  href={communityDataArr.repairDependsFile[0].response.showPath}
                  download={communityDataArr.repairDependsFile[0].name}
                >
                  下載會議記錄
                </a>
              )}
            </div>
            {/* )} */}
            <p>
              {`五年長期修繕剩餘金額 
               ${annualFixBudgetArr

                 .reduce(getBudgetReducer(5), 0)
                 .toLocaleString()}
                元`}
            </p>
            <p>
              {`十年長期修繕剩餘金額 
             ${annualFixBudgetArr
               .reduce(getBudgetReducer(10), 0)
               .toLocaleString()}
                元`}
            </p>
            <p>
              {`全部長期修繕剩餘金額 
                 ${annualFixBudgetArr
                   .reduce(getBudgetReducer(), 0)
                   .toLocaleString()}元`}
            </p>
            <EditBalance />
          </div>
          {/* )} */}
        </Card.Content>
      </Card>
      <br /> <br />
      <>
        <Button
          onClick={() => {
            setCommunityDeviceUpdate({});
            setCommunityDeviceDialog(true);
            setCommunityDeviceStatus('insert');
            longTermFixAddForm.resetFields();
          }}
        >
          新增
        </Button>
        <EditRepairSubjectButtonWithModal
          {...{ backStageUpdateTrigger, setBackStageUpdateTrigger }}
        />
        <EditDocument name="長期修繕計畫管理" />
      </>
      {/* 新增修改年度修繕預算 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={communityDeviceDialog}
        onOk={() => {
          longTermFixAddForm.submit();
        }}
        onCancel={() => {
          setCommunityDeviceDialog(false);
        }}
        onClose={() => {
          setCommunityDeviceDialog(false);
        }}
      >
        <h1>
          {communityDeviceStatus === 'insert' ? '新增' : '修改'}長期修繕記錄
        </h1>

        <Form
          form={longTermFixAddForm}
          name="dynamic_form_item"
          onFinish={onFinish}
          initialValues={{ repairNum: 0 }}
          labelAlign="left"
          onFieldsChange={handleFieldsChange}
        >
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇長期修繕類別',
              },
            ]}
            label="修繕類別"
            name="category"
          >
            <Select
              className={styles.options}
              onChange={async (value) => {
                setRepairCategory(value);
              }}
            >
              {repairSubjects.length > 0 &&
                repairSubjects.map((s) => (
                  <Option key={s._id} value={s._id}>
                    {s.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          {repairCategory === 'communityDevice' ||
          repairCategory === 'publicInformation' ? (
            <Form.Item
              {...formItemLayout}
              rules={[
                {
                  required: true,
                  message: '請選擇設備名稱',
                },
              ]}
              label="名稱"
              name="deviceId"
            >
              <Select
                className={styles.options}
                placeholder="請選擇設備名稱"
                aria-label="name is"
              >
                {communityDeviceArr.map((item) => (
                  <Option value={item._id} key={item._id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item
              {...formItemLayout}
              rules={[
                {
                  required: true,
                  message: '請選擇設備名稱',
                },
              ]}
              label="名稱"
              name="name"
            >
              <Input />
            </Form.Item>
          )}
          <Form.Item
            label="修繕週期"
            initialValue={currentCycle}
            name="repairCycle"
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇修繕週期',
              },
            ]}
          >
            <Select>
              <Option value="year">年</Option>
              <Option value="month">月</Option>
              <Option value="week">週</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="修繕時間"
            name="repairTime"
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇修繕時間',
              },
            ]}
          >
            <Cascader
              expandTrigger="hover"
              options={getRepairTimeOptions(currentCycle)}
              multiple
            />
          </Form.Item>
          <Form.Item
            label="預計修繕總費用"
            name="repairExpenses"
            rules={[
              {
                required: true,
                message: '請輸入預計修繕總費用',
              },
            ]}
            {...formItemLayout}
          >
            <InputNumber min={0} />
          </Form.Item>
          <Form.Item
            label="修繕年度"
            name="repairStartAndEnd"
            rules={[
              {
                required: true,
                message: '請選擇修繕年度',
              },
            ]}
            {...formItemLayout}
          >
            <RangePicker type="year" />
          </Form.Item>
        </Form>
      </Dialog>
      {/* 查看維修記錄 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={annualFixBudgetDialog}
        onOk={() => {
          setAnnualFixBudgetDialog(false);
        }}
        onCancel={() => {
          setAnnualFixBudgetDialog(false);
        }}
        onClose={() => {
          setAnnualFixBudgetDialog(false);
        }}
      >
        <h1>查看長期修繕記錄</h1>
        <Button
          type="normal"
          onClick={() => setAnnualFixBudgetRecordDialog(true)}
          style={{ marginBottom: '20px' }}
        >
          新增修繕記錄
        </Button>
        <Table dataSource={communityDeviceUpdate.repairRecords}>
          <Table.Column
            dataIndex="createdTime"
            title="維修時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />
          <Table.Column dataIndex="repairRecordStatus" title="修繕狀態" />
          <Table.Column dataIndex="repairRecordText" title="修繕記錄" />
          <Table.Column dataIndex="repairRecordMoney" title="修繕金額" />
          <Table.Column dataIndex="repairRecordPerson" title="修繕人員" />
        </Table>
      </Dialog>
      {/* 新增編輯維修記錄 */}
      <Dialog
        name="dynamic_form_item"
        hasMask
        className={styles.dialog}
        visible={annualFixBudgetRecordDialog}
        onOk={() => {
          longTermFixRecordForm.submit();
        }}
        onCancel={() => {
          setAnnualFixBudgetRecordDialog(false);
        }}
        onClose={() => {
          setAnnualFixBudgetRecordDialog(false);
        }}
      >
        <h1>新增修繕記錄</h1>
        <Form
          form={longTermFixRecordForm}
          onFinish={onFinishRecord}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            label="設備狀態"
            name="repairRecordStatus"
            rules={[
              {
                required: true,
                message: '請選擇維修狀態',
              },
            ]}
            {...formItemLayout}
          >
            <RadioGroup aria-labelledby="groupId">
              <Radio value="處理中">處理中</Radio>
              <Radio value="已處理">已處理</Radio>
            </RadioGroup>
          </Form.Item>
          <Form.Item
            label="修繕記錄"
            name="repairRecordText"
            rules={[
              {
                required: false,
                message: '請輸入修繕記錄',
              },
            ]}
            {...formItemLayout}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="修繕金額"
            name="repairRecordMoney"
            rules={[
              {
                required: true,
                message: '請輸入修繕單次費用',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="修繕人員"
            name="repairRecordPerson"
            rules={[
              {
                required: true,
                message: '請輸入修繕人員',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
        </Form>
      </Dialog>
      <br />
      <br />
      <Card free>
        <Card.Content>
          <Table dataSource={annualFixBudgetArr}>
            <Table.Column
              title="修繕類別"
              width={100}
              dataIndex="category"
              cell={(value) => {
                return (
                  repairSubjects.find((subject) => subject._id === value)
                    ?.name || ''
                );
              }}
            />
            <Table.Column title="修繕名稱" width={100} dataIndex="name" />
            <Table.Column
              title="修繕合約期間"
              width={150}
              cell={(_value, _index, record) =>
                `${moment(record.repairStartYear).format('YYYY')}年至${moment(
                  record.repairEndYear
                ).format('YYYY')}年`
              }
            />
            <Table.Column
              title="修繕時間"
              width={150}
              cell={(_, _2, record) => {
                let displayTime = '';
                if (record.repairCycle === 'year') {
                  const times = record.repairTime;
                  displayTime = `每年：${times
                    .map((t) => {
                      if (t.length === 1) {
                        return `${t[0]}月`;
                      } else {
                        return `${t[0]}月${t[1]}日`;
                      }
                    })
                    .join('、')}`;
                } else if (record.repairCycle === 'month') {
                  const times = record.repairTime;
                  displayTime = `每月：${times
                    .map((t) => `${t[0]}日`)
                    .join('、')}`;
                } else if (record.repairCycle === 'week') {
                  const times = record.repairTime;
                  displayTime = `每週：${times
                    .map((t) => moment().set('weekday', t[0]).format('dddd'))
                    .join('、')}`;
                } else {
                  displayTime = '無設定';
                }
                return displayTime;
              }}
            />
            <Table.Column
              title="預計修繕總金額"
              width={100}
              dataIndex="repairExpenses"
              cell={(value) => `${value.toLocaleString()}元`}
            />
            <Table.Column
              title="目前剩餘金額"
              width={100}
              dataIndex="repairBalance"
              cell={(value) => `${value.toLocaleString()}元`}
            />
            <Table.Column
              title="操作"
              width={100}
              cell={(_value, _index, record) => {
                return (
                  <div className={styles.btnGroup}>
                    <Button
                      type="primary"
                      onClick={() => {
                        setCommunityDeviceUpdate(record);
                        setAnnualFixBudgetDialog(true);
                      }}
                    >
                      查看長期修繕記錄
                    </Button>
                    <Button
                      type="normal"
                      onClick={() => {
                        setCommunityDeviceStatus('update');
                        setCommunityDeviceUpdate(record);
                        setCommunityDeviceDialog(true);
                        setRepairCategory(record.category);
                        setCurrentCycle(record.repairCycle);
                        longTermFixAddForm.setFieldsValue({
                          ...record,
                          repairStartAndEnd: [
                            moment(record.repairStartYear),
                            moment(record.repairEndYear),
                          ],
                        });
                      }}
                    >
                      編輯
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        longTermFix
                          .remove(record._id)
                          .then(() => {
                            Message.success('刪除成功');
                            setBackStageUpdateTrigger({});
                          })
                          .catch((error) => console.error(error));
                      }}
                      warning
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default RepairBudgetList;
